import ManageGroupPopup from './ManageGroupPopup';

export default ManageGroupPopup;
